import { useAtomValue } from 'jotai'
import React from 'react'

import {
  buildNineSegmentsTableColumns,
  type NineSegmentColumnKey,
} from '~/apps/ninesegsAnalyzer/utils/customerAnalysis'
import { type ColumnInfo } from '~/utils'

import { nineSegmentHiddenColumnKeysAtom } from '../atoms'

export const useNineSegmentsTableColumns =
  (): ColumnInfo<NineSegmentColumnKey>[] => {
    const hiddenColumnKeys = useAtomValue(nineSegmentHiddenColumnKeysAtom)

    return React.useMemo(
      () => buildNineSegmentsTableColumns({ hiddenColumnKeys }),
      [hiddenColumnKeys],
    )
  }
